/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let pendingFetchUser = null;
let pendingWebsiteInfos = null;
let pendingFootball = null;
let pendingFbMatches = null;

const store = new Vuex.Store({
    state: {
        fb_order: {
            fb_matches: [],
        },
        androidVersion: '1.1.0',
        authUser: JSON.parse(localStorage.getItem("userData")) || {},
        amount: 0.0,
        totalWithdraw: 0.0,
        betAmount: null,
        twod_slip_data: [],
        threed_slip_data: [],
        twod_numbers: [],
        threed_numbers: [],
        language: localStorage.getItem("language") || "mm",
        websiteInfo: [],
        football: null,
    },
    mutations: {
        SET_USER(state, value) {
            state.authUser = value;
        },
        setTotalWithdraw(state, value) {
            state.totalWithdraw = value;
        },
        setBetAmount(state, value) {
            state.betAmount = value;
        },
        setAmount(state, value) {
            state.amount = value;
        },
        setTwodSlip(state, value) {
            state.twod_slip_data = value;
        },
        setThreedSlip(state, value) {
            state.threed_slip_data = value;
        },
        setTwodnumbers(state, value) {
            state.twod_numbers = value;
        },
        setThreednumbers(state, value) {
            state.threed_numbers = value;
        },
        setLanguage(state, value) {
            state.language = value;
        },
        setIsDeposits(state, value) {
            state.isDeposits = value;
        },
        setIsWithdraws(state, value) {
            state.isWithdraws = value;
        },
        setWholeFBMatches(state, data) {
            state.fb_order.fb_matches = [];
            state.fb_order.fb_matches = data;
        },
        setFBMatches(state, value) {
            state.fb_order.fb_matches.push(value);
        },
        updateFBMatches(state, data) {
            state.fb_order.fb_matches.splice(data.index, 1);
            state.fb_order.fb_matches[data.index] = data.value;
        },
        removeFBMatch(state, index) {
            state.fb_order.fb_matches.splice(index, 1);
        },
        updateFBOrder(state, data) {
            state.fb_order[data.type] = data.value;
        },
        setWebsiteInfo(state, value) {
            state.websiteInfo = value || [];
        },
        setFootball(state, value) {
            state.football = value;
        },
    },
    actions: {
        async fetchUser({ commit }) {
            if (pendingFetchUser) {
                return pendingFetchUser;
            }

            pendingFetchUser = axios.get('/auth/user', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then((userRes) => {
                    commit('SET_USER', userRes.data.data);
                    commit('setAmount', userRes.data.data.amount);
                    commit('setTotalWithdraw', userRes.data.totalWithdraw);
                    localStorage.setItem('userData', JSON.stringify(userRes.data.data));
                    return userRes.data.data;
                })
                .catch(() => null)
                .finally(() => {
                    pendingFetchUser = null;
                });

            return pendingFetchUser;
        },
        async fetchWebsiteInfos({ commit, state }) {
            if (state.websiteInfo.length > 0) {
                return state.websiteInfo;
            }
            if (pendingWebsiteInfos) {
                return pendingWebsiteInfos;
            }

            pendingWebsiteInfos = axios.get('/website-infos')
                .then((res) => {
                    const data = res.data.data || [];
                    commit('setWebsiteInfo', data);
                    return data;
                })
                .catch(() => [])
                .finally(() => {
                    pendingWebsiteInfos = null;
                });

            return pendingWebsiteInfos;
        },
        async fetchFootball({ commit, state }) {
            if (state.football) {
                return state.football;
            }
            if (pendingFootball) {
                return pendingFootball;
            }

            pendingFootball = axios.get('/football')
                .then((res) => {
                    const data = res.data.data[0];
                    commit('setFootball', data);
                    return data;
                })
                .catch(() => null)
                .finally(() => {
                    pendingFootball = null;
                });

            return pendingFootball;
        },
        async fetchFbMatches() {
            if (pendingFbMatches) {
                return pendingFbMatches;
            }

            pendingFbMatches = axios.get('fb-matches', {
                params: { isFromClient: true },
            })
                .then((res) => res.data.data || [])
                .catch(() => [])
                .finally(() => {
                    pendingFbMatches = null;
                });

            return pendingFbMatches;
        },
        async logoutUser({ commit }) {
            await axios.post('/auth/logout', null, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            commit('SET_USER', {});
            commit('setAmount', 0.0);
            localStorage.removeItem('userData');
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpire');
        },
    },
    getters: {
        getFBOrder(state) {
            return state.fb_order;
        },
        getFootball(state) {
            return state.football;
        },
    },
});

export default store;
